import { FC } from 'react';

import { formatDateTime } from '../utils/redemption.utils';

interface Props {
  fullCode: string;
  history: Array<{ sharedAt: Date; unsharedAt?: Date }>;
  onClose: () => void;
}

export const ShareHistoryModal: FC<Props> = ({ fullCode, history, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/50" onClick={onClose} />
      <div className="relative max-h-[80vh] w-full max-w-md overflow-hidden rounded-xl bg-white shadow-2xl">
        <div className="border-b bg-purple-50 px-6 py-4">
          <h3 className="text-lg font-bold text-purple-800">
            공유 이력 - {fullCode}
          </h3>
          <p className="mt-1 text-sm text-purple-600">
            총 <span className="font-bold">{history.length}회</span> 공유
          </p>
        </div>
        <div className="max-h-[60vh] overflow-y-auto px-6 py-4">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500">
                  #
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500">
                  공유 시각
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500">
                  공유 해제 시각
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {history.map((item, idx) => (
                <tr key={idx} className="hover:bg-gray-50">
                  <td className="whitespace-nowrap px-3 py-2 text-xs text-gray-500">
                    {idx + 1}
                  </td>
                  <td className="whitespace-nowrap px-3 py-2 text-xs text-gray-900">
                    {formatDateTime(item.sharedAt)}
                  </td>
                  <td className="whitespace-nowrap px-3 py-2 text-xs text-gray-900">
                    {item.unsharedAt ? formatDateTime(item.unsharedAt) : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="border-t px-6 py-3">
          <button
            onClick={onClose}
            className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};
